import { SponsoredCardTranslation } from "@models/sponsored-card-translation-model";
import { useTranslation } from "react-i18next";
import { normalizeLink } from "@utils/sharedFunctions";

// Helper per inviare messaggi a React Native
const postToNative = (type: string, data: object) => {
  const msg = JSON.stringify({ type, data });
  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage(msg);
  } else {
    // Fallback browser normale (fuori dall'app)
    if (type === 'OPEN_URL' && 'url' in data) {
      window.open((data as any).url, '_blank');
    }
  }
};

export default function CardSponsored(props: { sponsoredCardTranslation: SponsoredCardTranslation }) {
   const { t } = useTranslation();
   if (!props) return null;
   const { detail, title, sponsoredCard } = props.sponsoredCardTranslation;

   const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      const url = normalizeLink(sponsoredCard?.link) ?? `https://www.google.com/search?q=${title}`;
      postToNative('OPEN_URL', { url });
   };

   return (
      <a role="button"
         rel="noreferrer"
         href={normalizeLink(sponsoredCard?.link) ?? `https://www.google.com/search?q=${title}`}
         onClick={handleClick}
         className="d-flex w-100 flex-column text-decoration-none rounded-3 overflow-hidden shadow-sm border border-light-subtle bg-white h-100"
         style={{ transition: 'transform 0.2s, box-shadow 0.2s' }}
         onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)';
            (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
         }}
         onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
            (e.currentTarget as HTMLElement).style.boxShadow = '';
         }}
      >
         <div style={{ width: '100%', overflow: 'hidden' }}>
            <img
               src={`data:image/png;base64,${sponsoredCard?.photo}`}
               alt={title}
               className="w-100"
               style={{
                  objectFit: 'contain',
                  display: 'block'
               }}
            />
         </div>

         <div className="p-3 d-flex flex-column justify-content-between flex-grow-1">
            <div>
               <h3 className="fs-6 fw-bold mb-1 text-dark">{title}</h3>
               <p className="text-secondary small mb-0" style={{ lineHeight: '1.5' }}>
                  {detail}
               </p>
            </div>
            <div className="d-flex justify-content-end mt-2">
               <span className="badge text-bg-warning small fst-italic fw-normal" style={{ fontSize: '0.7rem' }}>
                  ⭐ {t("text.sponsored")}
               </span>
            </div>
         </div>
      </a>
   );
}